import {
  CookiesEnum,
  cookiesValues,
  DEFAULT_COUNTRY_CODE,
  SUBSCRIPTION_STATUS,
} from "@/constants/constants";
import { Column, Row } from "./Stack";
import { Text } from "./Text";
import { Button } from "./Button";
import { getClientSideCookieValue, isTvEnv } from "@/utils/common.helpers";
import { useEffect, useRef, useState } from "react";
import { useClientTranslations } from "@/hooks/useClientTranslations";
import { AppDownloadPopup } from "./AppDownloadPopup";
import { useRouter } from "next/navigation";
import { useFocusable } from "@noriginmedia/norigin-spatial-navigation";
import { tvBackButtonOverrideHandler } from "@/utils/tv.helpers";

export const SubscriptionDetails = () => {
  const [isSubscriptionActive, setIsSubscriptionActive] = useState(false);
  const router = useRouter();
  const [showAppDownloadModal, setShowAppDownloadModal] = useState(false);
  const { t } = useClientTranslations();
  const hasFetched = useRef(false);
  const userSubscriptionStatus = getClientSideCookieValue(
    cookiesValues[CookiesEnum.Status],
  );
  const { ref: subscriptionCtaRef, focused: subscriptionCtaFocused } =
    useFocusable({
      focusKey: "SUBSCRIPTION_CTA",
      onEnterPress: () => {
        handleSubscriptionCta();
      },
    });

  useEffect(() => {
    if (!hasFetched.current) {
      hasFetched.current = true;
    }
  }, []);

  useEffect(() => {
    const shouldBeActive =
      userSubscriptionStatus === SUBSCRIPTION_STATUS.SUBSCRIBED.toString();
    setIsSubscriptionActive((currentValue) => {
      if (shouldBeActive !== currentValue) {
        return shouldBeActive;
      }
      return currentValue;
    });
  }, [userSubscriptionStatus]);
  const closeAppDownloadModal = () => {
    setShowAppDownloadModal(false);
  };
  useEffect(() => {
    if (showAppDownloadModal) {
      tvBackButtonOverrideHandler.set(() => closeAppDownloadModal());
      return () => {
        tvBackButtonOverrideHandler.clear();
      };
    }
  }, [showAppDownloadModal, closeAppDownloadModal]);
  const subscriptionCtaText = () => {
    if (userSubscriptionStatus === SUBSCRIPTION_STATUS.SUBSCRIBED.toString()) {
      return `${t("setting_page.manage_subscription")}`;
    } else if (
      userSubscriptionStatus === SUBSCRIPTION_STATUS.NOT_SUBSCRIBED.toString()
    ) {
      return `${t("setting_page.purchase_trial")}`;
    } else {
      return `${t("setting_page.purchase_subscription")}`;
    }
  };

  const handleSubscriptionCta = () => {
    if (isSubscriptionActive) {
      setShowAppDownloadModal(true);
    } else {
      router.push(`/${isTvEnv() ? "checkout" : "paywall"}?source=settings`);
    }
  };

  const toggleAppDownloadModal = () => {
    setShowAppDownloadModal((prev) => !prev);
  };

  const ctaText = subscriptionCtaText();

  return (
    <div className="w-full rounded-lg bg-[var(--grey-2-40)] p-4">
      <Column gap={2} fullWidth={true}>
        {/* <Row gap={1} align="center" fullWidth={true} justify="start">
        <Text
          weight="bold"
          dangerouslyDisableDefaultTextColor={true}
          classNames={getSubscriptionStatusColor()}
        >
          // subscription_status text
          <span className=" text-[1.12rem]">
            {mandateDetails?.subscription_status
              ? subscriptionStatus(mandateDetails.subscription_status)
              : ""}
          </span>
        </Text>

        <div className=" flex h-[1.87rem] items-center gap-[10px] rounded-lg bg-[--grey-3] px-2 py-1">
          <Text size={2}>
            {subscriptionDetails?.status?.currentBillingCycle?.planValid
              ? subscriptionDetails.status.currentBillingCycle.planValid
              : "No plan found"}
          </Text>
        </div>
      </Row> */}
        <Row gap={1} align="end" fullWidth={true} justify="spaceBetween">
          <Text size={isTvEnv() ? 5 : 3}>
            {(() => {
              const userData = JSON.parse(
                decodeURIComponent(
                  getClientSideCookieValue(
                    cookiesValues[CookiesEnum.UserData],
                  ) || "%7B%7D",
                ),
              );
              return `${userData.countryCode ?? DEFAULT_COUNTRY_CODE} ${userData.mobileNumber ?? ""}`;
            })()}
          </Text>
          {/* TODO: To add renewal status text 
        // renewal status text 
       <Column>
          <Text appearance="secondary" size={2} weight="medium">
            {getRenewalStatusText()}
          </Text>
          <Text size={2}>21 December, 2025</Text>
        </Column>  */}
        </Row>

        {!userSubscriptionStatus ? (
          <div
            className={`relative h-[3rem] w-full overflow-hidden rounded-md border border-white/25 bg-black`}
          >
            <div className="absolute inset-0 -translate-x-full animate-shimmer bg-gradient-to-r from-transparent via-white/10 to-transparent"></div>
            <div className="flex h-full items-center justify-center">
              <div className="h-5 w-32 rounded bg-white/20"></div>
            </div>
          </div>
        ) : (
          <Button
            onClick={() => handleSubscriptionCta()}
            variant="primary"
            ref={subscriptionCtaRef}
            className={`group border-2 border-white/25 ${userSubscriptionStatus === SUBSCRIPTION_STATUS.SUBSCRIBED.toString() ? "!bg-stg-grey-1 hover:!bg-white" : "hover:opacity-80"} ${subscriptionCtaFocused ? "border-2 border-white" : "bg-stg-grey-2"}`}
          >
            <Text
              weight="bold"
              classNames={
                userSubscriptionStatus ===
                SUBSCRIPTION_STATUS.SUBSCRIBED.toString()
                  ? "group-hover:!text-black"
                  : ""
              }
            >
              <span className={isTvEnv() ? "text-[1.25rem]" : "text-[1.12rem]"}>
                {ctaText}
              </span>
            </Text>
          </Button>
        )}
      </Column>
      <AppDownloadPopup
        toggleDownloadPopup={toggleAppDownloadModal}
        initialState={showAppDownloadModal}
        sourcePage="settings"
      />
    </div>
  );
};
